function isNeibu() {
    return /neibu/.test(window.location.hostname);
}

function loginCrm({ telephone }) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: `//crm-crystal.${isNeibu() ? 'neibu.' : ''}koolearn.com/outer/save/fromdata`,
            type: 'get',
            dataType: 'jsonp',
            data: {
                // 产品分组id
                productGroup: '16',
                // 固定传1
                dataSource: '1',
                // 页面二级来源, 与PM协定后写入，便于后台查找
                sourceTitle: '考研流量M站-新用户',
                // 手机号
                phone: telephone,
                // 当前页面url
                sourceUrl: window.location.href,
            },
        }).done((data) => {
            if (data.suc == 0) {
                console.log(`crm信息提交成功：${telephone}`);
                resolve();
            } else if (data.suc == 1) {
                console.log('信息已提交');
                resolve();
            } else {
                console.log('信息提交失败，请重试');
                reject();
            }
        }).fail((error) => {

        });
    });
}

export const showInterestEvent = 'ky-login_show-interest-label';

export const DIALOG_NO_PASS_LOGIN_EVENT = 'g-dialog-nopass-login_login-success';

export const DIALOG_NO_MIMA_LOGIN_EVENT = 'g-dialog-nopass-login_mima_login-success';

export default function kaoyanLogin({ f, channel, showModal = true }) { // 默认是true,为了减少改动
    let result = {};
    return new Promise((resolve, reject) => {
        // 判断是否已登录
        if (document.cookie.indexOf('sso.ssoId=') > -1 || document.cookie.indexOf('sid=') > -1) {
            resolve();
        }

        $(window).on(DIALOG_NO_PASS_LOGIN_EVENT, (event, data) => {
            // 新用户注册
            // 宏任务后执行
            setTimeout(() => {
                if (data.loginType == 1) {
                    // 触发展示选择兴趣标签的弹窗
                    if (showModal) {
                        $(window).trigger(showInterestEvent, {
                            ...data,
                            cb: (showLoginCrm) => { // 将 resolve 作为参数传递进去
                                if (showLoginCrm) {
                                    loginCrm({ telephone: result.mobile }).then(() => {
                                        resolve({ ...result, ...data });
                                        $(window).off(DIALOG_NO_PASS_LOGIN_EVENT);
                                    });
                                } else {
                                    // TODO : 线索上报
                                    resolve({ ...result, ...data });
                                    $(window).off(DIALOG_NO_PASS_LOGIN_EVENT);
                                }
                            },
                        });
                    } else {
                        loginCrm({ telephone: result.mobile }).then(() => {
                            resolve({ ...result, ...data });
                            $(window).off(DIALOG_NO_PASS_LOGIN_EVENT);
                        });
                    }
                } else {
                    resolve({ ...result, ...data });
                    $(window).off(DIALOG_NO_PASS_LOGIN_EVENT);
                }
            }, 0);
        });

        $(window).on(DIALOG_NO_MIMA_LOGIN_EVENT, (event, data) => {
            resolve({ ...result, ...data });
            $(window).off(DIALOG_NO_MIMA_LOGIN_EVENT);
        });

        $.telLogin && $.telLogin({
            f,
            channel, // 这个值就是m-kaoyan
        }).then((data) => {
            // 微任务先执行
            result = data;
        });
    });
}
